export const JOB_DONE_EVENT_PREFIX = "RealQueue/JobDone/";
